import { render, staticRenderFns } from "./IntegracaoConfiguracaoComponent.vue?vue&type=template&id=dfcce5a0&scoped=true"
import script from "./IntegracaoConfiguracaoComponent.vue?vue&type=script&lang=js"
export * from "./IntegracaoConfiguracaoComponent.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoConfiguracaoComponent.vue?vue&type=style&index=0&id=dfcce5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcce5a0",
  null
  
)

export default component.exports